import { useTechnologicalMap } from '@app/components/RecordModal/components/TechnologicalMap/hooks';
import { PREFIX } from '@app/constants';

import '@app/components/RecordModal/components/TechnologicalMap/styles/TechnologicalMap.desktop.scss';

export const TechnologicalMap: React.FC = () => {
  const { getTechnologicalMapContent } = useTechnologicalMap();

  return (
    <div className={`${PREFIX}technological-map`}>
      {getTechnologicalMapContent()}
    </div>
  );
};
